import { tmpPrivate, tmpPublic } from '~/amplify/getConfig';

const isTemporaryImagePath = (s3key: string): boolean =>
  s3key.startsWith(tmpPrivate) || s3key.startsWith(tmpPublic);

export default isTemporaryImagePath;
